/**
 * Serialize a captured value for a Ryn Replay event, truncated to `maxChars`.
 * Never throws: a broken serializer must not take down the page being
 * recorded. Extracted from ryn-replay-devtools-capture.ts (#34222, 500-line
 * rule).
 */
export const safeSerialize = (value: unknown, maxChars: number): unknown => {
  try {
    if (typeof value === 'string') {
      return value.length > maxChars ? `${value.slice(0, maxChars)}…` : value;
    }
    if (
      typeof value === 'number' ||
      typeof value === 'boolean' ||
      value === null
    ) {
      return value;
    }
    if (value instanceof Error) {
      return {
        name: value.name,
        message: value.message.slice(0, maxChars),
      };
    }
    const json = JSON.stringify(value);
    if (json === undefined) {
      return String(value).slice(0, maxChars);
    }
    return json.length > maxChars
      ? `${json.slice(0, maxChars)}…`
      : JSON.parse(json);
  } catch {
    try {
      return String(value).slice(0, maxChars);
    } catch {
      return '[unserializable]';
    }
  }
};
